import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Company panel → Care Programmes: the app's four clinical support programmes.
 *
 *   Overview      all four side by side
 *   GLP-1         support alongside GLP-1 medication
 *   Pause         menopause and andropause
 *   Peptide Care  peptide protocols
 *   Fibromyalgia  living with chronic pain
 *
 * REPRODUCTIVE HEALTH IS A SEPARATE SECTION, not a fifth and sixth tab here.
 * Menstrual Care and Fertility Care sit at /reproductive-health so a customer
 * can be given one section and not the other, and the backend enforces that
 * split rather than trusting the URL — neither section's endpoint will serve
 * the other's programmes.
 *
 * THERE IS NO EMPLOYEES TAB, AND THAT IS THE POINT. Most sections in this panel
 * end with a per-person list. This one does not, because enrolment is itself
 * the disclosure: a list of who is in Fibromyalgia Care is a list of who has a
 * chronic pain condition, and a list of who is on GLP-1 is a list of who is
 * taking prescription weight-loss medication. Both are special-category health
 * data and both are protected characteristics.
 *
 * What the section is for instead: whether the benefit is reaching anybody and
 * whether people stay with it. Both are answerable without naming a single
 * person and without reading a single thing anybody recorded.
 */
const CompanyCareLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';
  const base = `/${slug}/care`;

  const pages = [
    {
      label: 'Overview',
      path: base,
      description: 'All four programmes side by side, and how many people use more than one'
    },
    {
      label: 'GLP-1',
      path: `${base}/glp-1`,
      description: 'Support alongside GLP-1 medication — take-up and check-in activity'
    },
    {
      label: 'Pause',
      path: `${base}/pause`,
      description: 'Menopause and andropause support — take-up and check-in activity'
    },
    {
      label: 'Peptide Care',
      path: `${base}/peptide`,
      description: 'Peptide protocols — take-up and check-in activity'
    },
    {
      label: 'Fibromyalgia',
      path: `${base}/fibromyalgia`,
      description: 'Chronic pain support — take-up and check-in activity'
    }
  ];

  return (
    <CompanySectionLayout
      title="Care Programmes"
      subtitle={`How many of your ${population} are using the four care programmes, and whether they stay with them. Take-up and engagement only — nothing anybody recorded is shown, nobody is named anywhere in this section, and groups too small to anonymise are not reported at all.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyCareLayout;
